var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redbag"},[(!_vm.isWeixin)?_c('button',{on:{"click":_vm.handleJump}}):_c('button',{on:{"click":_vm.handleCopy}})])
}
var staticRenderFns = []

export { render, staticRenderFns }